import { render } from "./RealityCheck.vue?vue&type=template&id=8eff9248"
import script from "./RealityCheck.vue?vue&type=script&lang=js"
export * from "./RealityCheck.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__